import axios from "axios"

import { paths } from "@src/app/paths"

axios.interceptors.response.use(undefined, (error) => {
  if (
    error?.response?.status === 401 &&
    window.location.pathname !== paths.auth
  ) {
    return window.location.replace(paths.auth)
  }

  return Promise.reject(error)
})
